import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const lenis = window.__lenis;
        if (hash) {
            const timer = setTimeout(() => {
                const el = document.querySelector(hash);
                if (!el) return;
                if (lenis) lenis.scrollTo(el, { offset: -96 });
                else el.scrollIntoView({ behavior: "smooth" });
            }, 80);
            return () => clearTimeout(timer);
        }
        if (lenis) lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};
